import { CopilotPlan, type PatsnapCopilotUsage } from '@analytics/patsnap-copilot/src/patsnap-copilot-service.interface';
import type { PatsnapCopilotUsageService } from '@analytics/patsnap-copilot/src/patsnap-copilot-usage-service';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { container } from './container';
import type { ICoreDataWrapper } from './exception';
import { controlDeferred } from '@eureka/utils/control';

@injectable()
export class CopilotChatUsageServiceImpl implements PatsnapCopilotUsageService {
    async getUsage(): Promise<PatsnapCopilotUsage> {
        const promise = container.RnDHttp.get<ICoreDataWrapper<{
            copilot_limitation: number;
            copilot_usage: number;
            copilot_google_flag: boolean;
        }>>({
            url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/copilot/chat_init`,
        }).then(res => {
            const {
                copilot_limitation,
                copilot_usage,
                copilot_google_flag,
            } = res.data || {};

            return {
                currentAmount: copilot_usage,
                maxAmount: copilot_limitation,
                webAccess: copilot_google_flag,
            };
        }).catch(() => {
            return {
                currentAmount: 0,
                maxAmount: 0,
            };
        });

        const [
            { chat: enabled },
            usage
        ] = await Promise.all([
            controlDeferred.promise,
            promise
        ]);

        return {
            ...usage,
            enabled,
            plan: CopilotPlan.A,
            upgradeInvite: false,
        }
    }
}
